import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import QRCode from 'qrcode.react';

import { getDate, formatMoney } from '../../utils/functions/Utils';

function FormatoFactura(props) {

    const [data, setData] = useState(null);
    const [renderHoja, setRenderHoja] = useState(<></>);
    const [emisor, setEmisor] = useState({
        denominacion: 'Comercializadora de Servicios Integrales Juvalfri',
        regimenFiscal: '626 - Régimen Simplificado de Confianza',
        rfc: 'CSI200211-SI1',
        direccion: 'Quiches No. 19 Int. 4, Col. La Raza, Azcapotzalco, México CDMX',
        telefono: '55 4861-7332',
        administradorUnico: 'Ing. Abdias Lopez Reyes'
    });
    const [receptor, setReceptor] = useState({
        denominacion: '',
        rfc: '',
        direccion: ''
    });
    const [factura, setFactura] = useState({
        noFactura: '',
        cfdi: '',
        fechaEmision: new Date(),
        subTotal: 0.00,
        iva: 0.00,
        total: 0.00,
        reportes: [],
        conceptos: [],
        estatus: 'PENDIENTE DE FIRMAS',
        serie: '',
        folio: '',
        folioActaEntrega: '',
        importeLetra: '',
        observaciones: '',
    });
    const [cfdi, setCfdi] = useState({});
    const [extendedFormat, setExtendedFormat] = useState(false);
    const [conceptosD, setConceptosD] = useState(null);
    const [reportesD, setReportesD] = useState(null);

    useEffect(() => {
        // console.log(props);
        // if(props.cfdi.conceptos){
        //     let tmpCfdi = props.cfdi;
        //     let tmp = props.cfdi.conceptos;
        //     props.cfdi.conceptos.forEach((cc, i) => {
        //         tmp[i]['$'].Descripcion = cc[i];
        //     })
        //     tmpCfdi.conceptos = tmp;
        //     setCfdi(tmpCfdi);
        // }
        // console.log("props", props);
        document.body.style.backgroundColor = '#fff';
        setFactura(props.factura);
        setEmisor(props.emisor);
        setReceptor(props.receptor);
        setReportesD(props.factura.reportes);
        setConceptosD(props.factura.conceptos);
        setCfdi(props.cfdi);
    }, [props])

    const printDocument = () => {
        let printContents = document.getElementById('printDiv').innerHTML;
        localStorage.setItem('printContent', JSON.stringify({ printContents: printContents, name: `F-${factura.serie + factura.folio} ${receptor.denominacion}` }));
        window.open('/print', '_blank');
    }


    const getEquipos = () => {
        return (
            <>
                <div className='d-flex justify-content-center'>
                    <div style={{ marginTop: '4px', width: '770px' }}>
                        <hr style={{ height: '2px', color: '#611c35', opacity: '75%', marginTop: '4px', marginBottom: '4px' }} />
                        {/* <p className='text-bold text-center mb-2' style={{ fontSize: '12px' }}>{factura.hospital}</p> */}
                        <div className='d-flex' style={{ color: '#000' }}>
                            <div style={{ width: '60px' }}>
                                <p className='text-bold text-center mb-0' style={{ fontSize: '11px' }}>Cantidad</p>
                            </div>
                            <div style={{ width: '60px' }}>
                                <p className='text-bold text-center mb-0' style={{ fontSize: '11px' }}>Unidad</p>
                            </div>
                            <div style={{ width: '70px' }}>
                                <p className='text-bold text-center mb-0' style={{ fontSize: '11px' }}>Clave</p>
                            </div>
                            <div style={{ width: '280px' }}>
                                <p className='text-bold text-center mb-0' style={{ fontSize: '11px' }}>Descripción</p>
                            </div>
                            <div style={{ width: '100px' }}>
                                <p className='text-bold text-center mb-0' style={{ fontSize: '11px' }}>Precio Unitario</p>
                            </div>
                            <div style={{ width: '100px' }}>
                                <p className='text-bold text-center mb-0' style={{ fontSize: '11px' }}>Impuestos</p>
                            </div>
                            <div style={{ width: '90px' }}>
                                <p className='text-bold text-center mb-0' style={{ fontSize: '11px' }}>Importe</p>
                            </div>
                        </div>
                        <hr className='my-1' style={{ color: "#445" }} />
                        {cfdi.conceptos.map((c, i) => {
                            return (
                                <div className='d-flex mb-2' style={{ color: '#000' }} key={cfdi.comprobante.Sello.substring(i, i + 5)}>
                                    <div style={{ width: '60px' }}>
                                        <p className='text-bold text-center' style={{ fontSize: '9px' }}>{c['$'].Cantidad}</p>
                                    </div>
                                    <div style={{ width: '60px' }}>
                                        <p className='text-bold text-center mb-1' style={{ fontSize: '9px' }}>{c['$'].ClaveUnidad === 'E48' ? 'SERVICIO - E48' : c['$'].ClaveUnidad === 'H87' ? 'PIEZA - H87' : c['$'].ClaveUnidad}</p>
                                    </div>
                                    <div style={{ width: '70px' }}>
                                        <p className='text-bold text-center' style={{ fontSize: '9px' }}>{c['$'].ClaveProdServ} </p>
                                    </div>
                                    <div style={{ width: '280px' }}>
                                        <p className='text-bold mb-0' style={{ fontSize: '9px' }}>{c['$'].Descripcion.toUpperCase()}</p>
                                    </div>
                                    <div style={{ width: '100px' }}>
                                        <p className='text-bold text-center' style={{ fontSize: '9px' }}>$ {formatMoney(c['$'].ValorUnitario)}</p>
                                    </div>
                                    <div style={{ width: '100px' }}>
                                        <p className='text-bold text-center mb-0' style={{ fontSize: '9px' }}>{c["cfdi:Impuestos"][0]["cfdi:Traslados"][0]["cfdi:Traslado"][0].$.Impuesto === '002' ? `002 - IVA ${c["cfdi:Impuestos"][0]["cfdi:Traslados"][0]["cfdi:Traslado"][0].$.TasaOCuota} %` : ''}</p>
                                        <p className='text-bold text-center mb-0' style={{ fontSize: '9px' }}>{`$ ${formatMoney(c["cfdi:Impuestos"][0]["cfdi:Traslados"][0]["cfdi:Traslado"][0].$.Importe)}`}</p>
                                    </div>
                                    <div style={{ width: '90px' }}>
                                        <p className='text-bold text-center mb-0' style={{ fontSize: '9px' }}>$ {formatMoney(c['$'].Importe)}</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>

            </>
        )
    }

    const getRelacionados = (re) => {
        switch (re) {
            case '01': return '01 - Nota de crédito de los documentos relacionados';
            case '02': return '02 - Nota de débito de los documentos relacionados';
            case '03': return '03 - Devolución de mercancía sobre facturas o traslados previos';
            case '04': return '04 - Sustitución de los CFDI previos';
            case '05': return '05 - Traslados de mercancías facturados previamente';
            case '06': return '06 - Factura generada por los traslados previos';
            case '07': return '07 - CFDI por aplicación de anticipo';
            case '08': return '08 - Factura generada por pagos en parcialidades';
            case '09': return '09 - Factura generada por pagos diferidos';
            default: return '';
        }
    }

    const getUsoCFDI = (u) => {
        switch (u) {
            case 'G01': return 'G01 - Adquisición de mercancías';
            case 'G02': return 'G02 - Devoluciones, descuentos o bonificaciones';
            case 'G03': return 'G03 - Gastos en general';
            default: return '';
        }
    }

    const getMetodoPago = (m) => {
        switch (m) {
            case 'PUE': return 'PUE - Pago en una sola exhibición';
            case 'PPD': return 'PPD - Pago en parcialidades o diferido';
            default: return '';
        }
    }

    const getFormaPago = (f) => {
        switch (f) {
            case '01': return '01 - Efectivo';
            case '02': return '02 - Cheque nominativo';
            case '03': return '03 - Transferencia electrónica de fondos';
            case '04': return '04 - Tarjeta de crédito';
            case '05': return '05 - Monedero electrónico';
            case '06': return '06 - Dinero electrónico';
            case '08': return '08 - Vales de despensa';
            case '12': return '12 - Dación en pago';
            case '13': return '13 - Pago por subrogación';
            case '14': return '14 - Pago por consignación';
            case '15': return '15 - Condonación';
            case '17': return '17 - Compensación';
            case '23': return '23 - Novación';
            case '24': return '24 - Confusión';
            case '25': return '25 - Remisión de deuda';
            case '26': return '26 - Prescripción o caducidad';
            case '27': return '27 - A satisfacción del acreedor';
            case '28': return '28 - Tarjeta de débito';
            case '29': return '29 - Tarjeta de servicios';
            case '30': return '30 - Aplicación de anticipos';
            case '31': return '31 - Intermediario pagos';
            case '99': return '99 - Por definir';
            default: return '';
        }
    }

    const getRegimenFiscal = (r) => {
        switch (r) {
            case '601': return '601 - General de Ley Personas Morales';
            case '603': return '603 - Personas Morales con Fines no Lucrativos';
            case '605': return '605 - Sueldos y Salarios e Ingresos Asimilados a Salarios';
            case '606': return '606 - Arrendamiento';
            case '608': return '608 - Demás ingresos';
            case '609': return '609 - Consolidación';
            case '610': return '610 - Residentes en el Extranjero sin Establecimiento Permanente en México';
            case '611': return '611 - Ingresos por Dividendos (socios y accionistas)';
            case '612': return '612 - Personas Físicas con Actividades Empresariales y Profesionales';
            case '614': return '614 - Ingresos por intereses';
            case '616': return '616 - Sin obligaciones fiscales';
            case '620': return '620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos';
            case '621': return '621 - Incorporación Fiscal';
            case '622': return '622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras';
            case '623': return '623 - Opcional para Grupos de Sociedades';
            case '624': return '624 - Coordinados';
            case '628': return '628 - Hidrocarburos';
            case '607': return '607 - Régimen de Enajenación o Adquisición de Bienes';
            case '629': return '629 - De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales';
            case '630': return '630 - Enajenación de acciones en bolsa de valores';
            case '615': return '615 - Régimen de los ingresos por obtención de premios';
            case '631': return '631 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas';
            case '626': return '626 - Régimen Simplificado de Confianza';
            default: return '';
        }
    }

    const getMoneda = (m) => {
        if (m === 'MXN') {
            return 'MXN - Pesos Mexicanos';
        } else {
            return m;
        }
    }


    const getBottomFormat = (extendedFormat) => {
        const info = <>
            <hr style={{ height: '2px', color: '#611c35', opacity: '75%' }} className='my-1 mx-4' />
            <div className='d-flex justify-content-arround mx-4'>
                <div style={{ width: '550px' }}>
                    <p className='my-0 mx-2' style={{ fontSize: '10px', color: '#000' }}>IMPORTE CON LETRA:</p>
                    <p className='my-0 mx-2 text-bold' style={{ fontSize: '10px', color: '#000' }}>{factura.importeLetra.toUpperCase()}</p>
                    <hr style={{ height: '2px', color: '#611c35', opacity: '75%' }} className='my-1 mx-2' />
                    <div className='d-flex mx-2 mb-2' style={{ color: '#000' }}>
                        <div style={{ width: '270px' }}>
                            <p className='text-bold mb-0' style={{ fontSize: '8px' }}>TIPO DE RELACIÓN: </p>
                            {cfdi.relacionados ? <p className='text-bold mb-0' style={{ fontSize: '7px' }}>{getRelacionados(cfdi.relacionados[0].$.TipoRelacion)}</p> : <></>}
                            {/* <p className='text-bold mb-0 mt-1 text-center' style={{ fontSize: '8px' }}>Método de pago: {getMetodoPago(cfdi.comprobante.MetodoPago)}</p> */}
                            <div style={{ width: '270px' }} className='mt-1'>
                                <p className='text-bold text-center mb-0' style={{ fontSize: '7px' }}>CONDICIONES DE PAGO</p>
                                <p className='text-bold text-center mb-0' style={{ fontSize: '6px' }}></p>
                            </div>
                            <div className='d-flex mt-1'>
                                <div style={{ width: '135px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <p className='text-bold text-center mb-0' style={{ fontSize: '7px' }}>MÉTODO DE PAGO:</p>
                                    <p className='text-bold text-center mb-0' style={{ fontSize: '6px' }}>{getMetodoPago(cfdi.comprobante.MetodoPago)}</p>
                                </div>
                                <div style={{ width: '135px' }}>
                                    <p className='text-bold text-center mb-0' style={{ fontSize: '7px' }}>FORMA DE PAGO</p>
                                    <p className='text-bold text-center mb-0' style={{ fontSize: '6px' }}>{getFormaPago(cfdi.comprobante.FormaPago)}</p>
                                </div>
                            </div>
                            <div className='d-flex mt-1'>
                                <div style={{ width: '135px' }}>
                                    <p className='text-bold text-center mb-0' style={{ fontSize: '7px' }}>No.CERTIFICADO EMISOR</p>
                                    <p className='text-bold text-center mb-0' style={{ fontSize: '6px' }}>{cfdi.comprobante.NoCertificado}</p>
                                </div>
                                <div style={{ width: '135px' }}>
                                    <p className='text-bold text-center mb-0' style={{ fontSize: '7px' }}>No.CERTIFICADO SAT</p>
                                    <p className='text-bold text-center mb-0' style={{ fontSize: '6px' }}>{cfdi.complemento.NoCertificadoSAT}</p>
                                </div>
                            </div>
                        </div>
                        <div style={{ width: '270px' }}>
                            <p className='text-bold mb-0' style={{ fontSize: '8px' }}>UUID RELACIONADO:</p>
                            {cfdi.relacionados ? <p className='text-bold mb-0' style={{ fontSize: '7px' }}>{cfdi.relacionados[0]["cfdi:CfdiRelacionado"][0].$.UUID}</p> : <></>}
                            <p className='text-bold text-center mb-0 mt-1' style={{ fontSize: '8px' }}>EFECTOS FISCALES AL PAGO</p>
                            <p className='text-bold text-center mb-0' style={{ fontSize: '7px' }}>CUENTA DE PAGO</p>
                            <p className='text-bold text-center mb-0' style={{ fontSize: '6px' }}>&nbsp;</p>
                            <div className='d-flex mt-1'>
                                <div style={{ width: '135px' }}>
                                    <p className='text-bold text-center mb-0' style={{ fontSize: '7px' }}>FECHA Y HORA DE CERTIFICACIÓN</p>
                                    <p className='text-bold text-center mb-0' style={{ fontSize: '6px' }}>{getDate(cfdi.complemento.FechaTimbrado, 'DDD')} - {getDate(cfdi.complemento.FechaTimbrado, 'HH:mm:ss')}</p>
                                </div>
                                <div style={{ width: '135px' }}>
                                    <p className='text-bold text-center mb-0' style={{ fontSize: '7px' }}>FOLIO FISCAL</p>
                                    <p className='text-bold text-center mb-0' style={{ fontSize: '6px' }}>{cfdi.complemento.UUID}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ color: '#000' }}>
                    <div className='d-flex' style={{ width: '200px' }}>
                        <p className='text-bold my-0' style={{ fontSize: '13px', width: '100px' }}>SUBTOTAL:</p>
                        <p className='text-bold my-0' style={{ fontSize: '13px', width: '100px', textAlign: 'end' }}>{formatMoney(cfdi.comprobante.SubTotal)}</p>
                    </div>
                    <div className='d-flex' style={{ width: '200px' }}>
                        <p className='text-bold my-0' style={{ fontSize: '13px', width: '100px' }}>DESCUENTO:</p>
                        <p className='text-bold my-0' style={{ fontSize: '13px', width: '100px', textAlign: 'end' }}>{formatMoney(cfdi.comprobante.Descuento)}</p>
                    </div>
                    <div className='d-flex' style={{ width: '200px' }}>
                        <p className='text-bold my-0' style={{ fontSize: '13px', width: '100px' }}>I.V.A. 16%:</p>
                        <p className='text-bold my-0' style={{ fontSize: '13px', width: '100px', textAlign: 'end' }}>{formatMoney(cfdi.totalImpuestos.TotalImpuestosTrasladados)}</p>
                    </div>
                    <div className='d-flex' style={{ width: '200px' }}>
                        <p className='text-bold my-0' style={{ fontSize: '13px', width: '100px' }}>TOTAL:</p>
                        <p className='text-bold my-0' style={{ fontSize: '13px', width: '100px', textAlign: 'end' }}>{formatMoney(cfdi.comprobante.Total)}</p>
                    </div>
                </div>
            </div>
            <div className='d-flex'>
                <div style={{ marginLeft: '24px' }}>
                    <QRCode
                        value={`https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?&id=${cfdi.complemento.UUID}&re=${cfdi.emisor.Rfc}&rr=${cfdi.receptor.Rfc}&tt=${cfdi.comprobante.Total}&fe=${cfdi.comprobante.Sello.slice(-8)}`}
                        size={128}
                        bgColor={"#ffffff"}
                        fgColor={"#000000"}
                        level={"Q"}
                        includeMargin={false}
                        renderAs={"svg"}
                    />
                </div>
                <div style={{ width: '610px', marginLeft: '20px', color: "#000" }}>
                    <p className='text-bold mb-0 text-center' style={{ fontSize: '9px' }}>SELLO DIGITAL DEL CFDI EMISOR</p>
                    <p className='text-break text-center mb-0 text-bold' style={{ fontSize: '6px', paddingBottom: '4px' }}>{cfdi.comprobante.Sello}</p>

                    <p className='text-bold mb-0 text-center' style={{ fontSize: '9px' }}>SELLO DEL SAT</p>
                    <p className='text-break text-center mb-0 text-bold' style={{ fontSize: '6px', paddingBottom: '4px' }}>{cfdi.complemento.SelloSAT}</p>

                    <p className='text-bold mb-0 text-center' style={{ fontSize: '9px' }}>CADENA ORIGINAL DEL COMPLEMENTO DE CERTIFICACIÓN DIGITAL DEL SAT</p>
                    <p className='text-center text-break text-bold mb-0' style={{ fontSize: '6px', width: '610px' }}>||{cfdi.complemento.Version}|{cfdi.complemento.UUID}|{cfdi.complemento.FechaTimbrado}|{cfdi.complemento.RfcProvCertif}|</p>
                    <p className='text-center text-break text-bold mb-1' style={{ fontSize: '6px', paddingBottom: '4px', width: '610px' }}>{cfdi.complemento.SelloCFD}|{cfdi.complemento.NoCertificadoSAT}||</p>
                    <p className='text-bold mb-0 text-center' style={{ fontSize: '9.5px' }}>"ESTE DOCUMENTO ES LA REPRESENTACIÓN IMPRESA DE UN CFDI"</p>
                </div>
            </div>
        </>
        if (extendedFormat) {
            return (
                <div style={{ width: '816px', left: '0px' }}>
                    {info}
                </div>
            )
        } else {
            return (
                <div style={{ position: 'absolute', bottom: '20px', width: '816px', left: '0px' }}>
                    {info}
                </div>
            )
        }
    }

    useEffect(() => {
        if (cfdi.comprobante) {
            document.title = `F-${factura.serie + factura.folio} ${receptor.denominacion}`;
            setRenderHoja(
                <div id='printDiv' style={{ position: 'absolute', width: '816px', height: '1056px', background: '#FFF', zIndex: '-1', transformOrigin: '0 0', transform: 'scale(1.4)' }} contentEditable="true" suppressContentEditableWarning={true}>
                    <div style={{ position: 'absolute', top: '25px', right: '24px', width: '340px', border: 'solid black 1.5px', borderRadius: '5px' }}>
                        <p style={{ color: '#000', fontSize: '10px', background: '#c0d8f4ff', borderBottom: 'solid black 1.5px', borderTopLeftRadius: '4px', borderTopRightRadius: '4px' }} className='text-bold mb-0 text-center'>
                            &nbsp;&nbsp;Factura electrónica CFDI - {cfdi.comprobante.Version}
                        </p>
                        <p className='text-center text-bold' style={{ fontSize: '22px', marginBottom: '-10px', color: "#000" }}>Factura</p>
                        <p className='text-center text-bold' style={{ fontSize: '26px', color: 'red', marginBottom: '-4px' }}>{factura.serie + ' ' + factura.folio}</p>
                        <hr className='my-1' style={{ color: "#445" }} />
                        <div className='d-flex align-items-stretch' style={{ width: '340px', color: '#000' }}>
                            <p style={{ width: '120px', fontSize: '9.5px' }} className='my-1 px-1 d-flex align-items-center'>Fecha:</p>
                            <p style={{ fontSize: '9.5px' }} className='my-1 px-1 text-bold'>{getDate(cfdi.comprobante.Fecha, 'DDD')} - {getDate(cfdi.comprobante.Fecha, 'HH:mm:ss')}</p>
                        </div>
                        <div className='d-flex align-items-stretch' style={{ width: '340px', color: '#000' }}>
                            <p style={{ width: '120px', fontSize: '9.5px' }} className='mb-1 px-1 d-flex align-items-center'>Lugar de Expedición:</p>
                            <p style={{ fontSize: '9.5px' }} className='mb-1 px-1 text-bold'>{cfdi.comprobante.LugarExpedicion}</p>
                        </div>
                        <div className='d-flex align-items-stretch' style={{ width: '340px', color: '#000' }}>
                            <p style={{ width: '120px', fontSize: '9.5px' }} className='mb-1 px-1 d-flex align-items-center'>Tipo de Comprobante:</p>
                            <p style={{ fontSize: '9.5px' }} className='mb-1 px-1 text-bold'>{cfdi.comprobante.TipoDeComprobante === 'I' ? 'I - Ingreso' : ''}</p>
                        </div>
                        <div className='d-flex align-items-stretch' style={{ width: '340px', color: '#000' }}>
                            <p style={{ width: '120px', fontSize: '9.5px' }} className='mb-1 px-1 d-flex align-items-center'>Folio Fiscal:</p>
                            <p style={{ fontSize: '9.5px' }} className='mb-1 px-1 text-bold'>{cfdi.complemento.UUID}</p>
                        </div>
                        <div className='d-flex align-items-stretch' style={{ width: '340px', color: '#000' }}>
                            <p style={{ width: '120px', fontSize: '9.5px' }} className='mb-1 px-1 d-flex align-items-center'>No. Certificado Emisor:</p>
                            <p style={{ fontSize: '9.5px' }} className='mb-1 px-1 text-bold'>{cfdi.comprobante.NoCertificado}</p>
                        </div>
                    </div>
                    <div style={{ marginTop: '20px', marginLeft: '24px' }}>
                        <img src={`/${props.configs.company}/logo_v-light.svg`} alt='juvalfri-logo' style={{ width: "230px", height: 'auto' }} />
                    </div>
                    {/* <div style={{marginLeft: '24px', marginTop: '0px', width: '420px'}}>
                        <p className='text-bold mb-0' style={{fontSize: '13px'}}>{cfdi.emisor.Nombre}</p>
                        <p className='text-bold mb-0' style={{fontSize: '11px'}}>{emisor.regimenFiscal}</p>
                        <p className='text-bold mb-0' style={{fontSize: '11px'}}>RFC: {emisor.rfc}</p>
                        <p className='text-bold mb-0' style={{fontSize: '10px'}}>{emisor.direccion}</p>
                        <p className='text-bold mb-0' style={{fontSize: '10px'}}>Tel: {emisor.telefono}</p>
                    </div> */}
                    <div style={{ marginLeft: '24px', marginTop: '4px', border: 'solid black 1.5px', borderRadius: '5px', width: '416px' }}>
                        <p style={{ color: '#000', fontSize: '10px', background: '#c0d8f4ff', borderBottom: 'solid black 1.5px', borderTopLeftRadius: '4px', borderTopRightRadius: '4px' }} className='text-bold mb-0'>
                            &nbsp;&nbsp;Emisor
                        </p>
                        <div style={{ padding: '4px', color: '#000' }}>
                            <p className='text-bold mb-0' style={{ fontSize: '12px' }}>{cfdi.emisor.Nombre}</p>
                            <p className='text-bold mb-0' style={{ fontSize: '10px' }}>{emisor.regimenFiscal}</p>
                            <p className='text-bold mb-0' style={{ fontSize: '10px' }}>R.F.C.: {emisor.rfc}</p>
                            <p className='text-bold mb-0' style={{ fontSize: '9px' }}>{emisor.direccion}</p>
                            <p className='text-bold mb-0' style={{ fontSize: '9px' }}>Tel: {emisor.telefono}</p>
                        </div>
                    </div>
                    <div className='d-flex justify-content-center'>
                        <div style={{ marginTop: '10px', width: '770px', border: 'solid black 1.5px', borderRadius: '5px' }}>
                            <p style={{ color: '#000', fontSize: '10px', background: '#c0d8f4ff', borderBottom: 'solid black 1.5px', borderTopLeftRadius: '4px', borderTopRightRadius: '4px' }} className='text-bold mb-0'>
                                &nbsp;&nbsp;Receptor
                            </p>
                            <div className='d-flex'>
                                <div className='d-flex align-items-stretch' style={{ color: '#000' }}>
                                    <p style={{ width: '34px', fontSize: '9px' }} className='my-1 px-1 d-flex align-items-center'>Cliente:</p>
                                    <p style={{ fontSize: '9px' }} className='my-1 px-1 text-bold'>{cfdi.receptor.Nombre}</p>
                                </div>
                                <div className='d-flex align-items-stretch' style={{ color: '#000' }}>
                                    <p style={{ width: '28px', fontSize: '9px' }} className='my-1 px-1 d-flex align-items-center'>R.F.C.:</p>
                                    <p style={{ fontSize: '9px' }} className='my-1 px-1 text-bold'>{receptor.rfc}</p>
                                </div>
                                <div className='d-flex align-items-stretch' style={{ color: '#000' }}>
                                    <p style={{ width: '62px', fontSize: '9px' }} className='my-1 px-1 d-flex align-items-center'>Uso de CFDI:</p>
                                    <p style={{ fontSize: '9px' }} className='my-1 px-1 text-bold'>{getUsoCFDI(cfdi.receptor.UsoCFDI)}</p>
                                </div>
                            </div>
                            <div className='d-flex'>
                                <div className='d-flex align-items-stretch' style={{ color: '#000' }}>
                                    <p style={{ width: '74px', fontSize: '9px' }} className='mb-1 px-1 d-flex align-items-center'>Régimen Fiscal:</p>
                                    <p style={{ fontSize: '9px' }} className='mb-1 px-1 text-bold'>{getRegimenFiscal(cfdi.receptor.RegimenFiscalReceptor)}</p>
                                </div>
                                <div className='d-flex align-items-stretch' style={{ color: '#000' }}>
                                    <p style={{ width: '44px', fontSize: '9px' }} className='mb-1 px-1 d-flex align-items-center'>Dirección:</p>
                                    <p style={{ fontSize: '9px' }} className='mb-1 px-1 text-bold'>{receptor.direccion}</p>
                                </div>
                            </div>
                            <hr className='my-1' style={{ color: '#445' }} />
                            <div className='d-flex'>
                                <div className='d-flex align-items-stretch' style={{ color: '#000' }}>
                                    <p style={{ width: '45px', fontSize: '9px' }} className='mb-1 px-1 d-flex align-items-center'>Moneda:</p>
                                    <p style={{ fontSize: '9px' }} className='mb-1 px-1 text-bold'>{getMoneda(cfdi.comprobante.Moneda)}</p>
                                </div>
                                <div className='d-flex align-items-stretch' style={{ color: '#000' }}>
                                    <p style={{ width: '80px', fontSize: '9px' }} className='mb-1 px-1 d-flex align-items-center'>Tipo de Cambio:</p>
                                    <p style={{ fontSize: '9px' }} className='mb-1 px-1 text-bold'>{cfdi.comprobante.TipoCambio}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {getEquipos()}

                    {getBottomFormat(extendedFormat)}

                </div>
            )
        } else {
            setRenderHoja(
                <>
                    <p className='h5 m-4'>No se ha validado ningún CFDI</p>
                </>
            )
        }
    }, [cfdi, factura, receptor, extendedFormat])

    return (
        <div>
            <div style={{ marginTop: '10px', marginBottom: '12px' }}>
                <Button variant='contained' className='mx-2' color='secondary' onClick={printDocument}>Imprimir factura &nbsp; <i className="fad fa-print"></i></Button>
                <Button variant='contained' className='mx-2' color='primary' onClick={() => setExtendedFormat(!extendedFormat)}>{`${extendedFormat ? 'Ver Formato Compacto' : 'Ver formato extendido'}`} &nbsp; <i className="fad fa-file-alt"></i></Button>
            </div>
            {renderHoja}
        </div>
    )
}

export default FormatoFactura;